// ─────────────────────────────────────────────────────────────────────────────
// Feature flags
//
// Toggle these to switch between mock data and live API data.
// When a flag is ON  → mock data is used, API calls are skipped.
// When a flag is OFF → live API data is used (production behaviour).
//
// Removal guide:
//   1. Set the flag to false and verify everything works.
//   2. Delete the corresponding mock data file.
//   3. Remove the import and the flag reference from the component.
// ─────────────────────────────────────────────────────────────────────────────

export const DASHBOARD_USE_MOCK_DATA = false;
export const ANALYTICS_USE_MOCK_DATA = false;
